import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AppShell, Container } from "@mantine/core";
import { useAuth } from "./contexts/AuthContext";
import Header from "./components/Layout/Header";
import SmartChatbot from "./components/SmartChatbot";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import FundDetails from "./pages/FundDetails";
import FundRecommendation from "./pages/FundRecommendation";
import Crowdfunding from "./pages/Crowdfunding";
import CreditScoring from "./pages/CreditScoring";
import Dashboard from "./pages/Dashboard";
import Register from "./pages/Register";
import Login from "./pages/Login";
import RecommendationHistory from "./pages/RecommendationHistory";
import PitchDeckPage from "./pages/PitchDeck";
import InvestorDetailsPage from "./pages/InvestorDetails";

function AppContent() {
  const { user } = useAuth();
  const isInvestor = user?.role === "investor";

  return (
    <AppShell header={{ height: 70 }} padding="md">
      <AppShell.Header>
        <Header />
      </AppShell.Header>

      <AppShell.Main>
        <Container size="xl" py="xl">
          <Routes>
            <Route
              path="/"
              element={
                isInvestor ? (
                  <Navigate to="/crowdfunding" replace />
                ) : (
                  <HomePage />
                )
              }
            />
            <Route
              path="/register"
              element={
                user?.role === "investor" ? (
                  <Navigate to="/crowdfunding" replace />
                ) : (
                  <Register />
                )
              }
            />
            <Route
              path="/login"
              element={
                user?.role === "investor" ? (
                  <Navigate to="/crowdfunding" replace />
                ) : (
                  <Login />
                )
              }
            />
            <Route
              path="/fund-details"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur"]}>
                  <FundDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fund-recommendation"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur"]}>
                  <FundRecommendation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pitch-deck"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur"]}>
                  <PitchDeckPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/investor-details"
              element={
                <ProtectedRoute allowedRoles={["investor"]}>
                  <InvestorDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recommendation-history"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur"]}>
                  <RecommendationHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crowdfunding"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur", "investor"]}>
                  <Crowdfunding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/credit-scoring"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur"]}>
                  <CreditScoring />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute allowedRoles={["entrepreneur"]}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Container>
        <SmartChatbot />
      </AppShell.Main>
    </AppShell>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
